import {
  InsulationProductType,
  mockInsulationProductWithCalculations,
} from '@innogy/feh/models';

export const mockInsulationReceiptViewModel = {
  unsuitableProducts: [InsulationProductType.VLOERISOLATIE],
  selectedProducts: [mockInsulationProductWithCalculations],
  maxYearlySavings: 420,
};
